import { Fragment } from 'react';
import { ErrorMessageText } from 'styles/form';
import { FormattedMessage } from 'react-intl';
import { isNil, isObject, isArray } from 'lodash';
import { Map, List } from 'immutable';
import { ifInTestingMode } from 'utils/tests.utils';

function ErrorMessage(props) {
  const { errors } = props;
  let messages = null;
  let errorsArray;

  // Convert to Array as required.
  if (Map.isMap(errors)) {
    // convert immutable Map to a JS Array of items
    errorsArray = errors.toList().toJS();
  } else if (List.isList(errors)) {
    // convert immutable List to JS Array
    errorsArray = errors.toJS();
  } else if (Object.prototype.toString.call(errors) === '[object Object]') {
    // Pure JS Object detection, convert to 'key: value' string,
    // except for 'nonFieldErrors' or 'detail' keys.
    errorsArray = Object.entries(errors).map(([key, value]) => {
      if (key === 'nonFieldErrors' || key === 'detail') {
        return value;
      }
      return `${key}: ${value[0]}`;
    });
  } else {
    // errors is already an array.
    errorsArray = errors;
  }

  if (!errorsArray || !errorsArray.length) {
    return null;
  }

  messages = errorsArray.map((error, key) => {
    let innerMessage = error;

    if (isObject(error) && !isArray(error)) {
      // @ts-expect-error TS(2339): Property 'translationId' does not exist on type 'o... Remove this comment to see the full error message
      innerMessage = <FormattedMessage id={error.translationId} />;
    }

    return (
      <ErrorMessageText
        // eslint-disable-next-line react/no-array-index-key
        key={`error-${key}`}
        data-testid={ifInTestingMode('error-message')}
      >
        {innerMessage}
      </ErrorMessageText>
    );
  });

  return <Fragment>{messages}</Fragment>;
}

ErrorMessage.defaultProps = {
  errors: [],
};

export default ErrorMessage;
